import classNames from "classnames";
import { FieldState } from "formstate";
import { observer } from "mobx-react";
import React from "react";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { useStore } from "../../../../../../models";
import settingsStyles from "../../../../../../styles/settings.css";
import { TagsList } from "../../../tagName/tagsList";
import tagGroupsStyles from "../tagGroups.css";
import styles from "./groupTags.css";

interface Props {
  tags: FieldState<string[]>;
}
export const GroupTags = observer(({ tags }: Props) => {
  const { tagsStore } = useStore();
  return (
    <div className={classNames(tagGroupsStyles.column, styles.column)}>
      <p className={classNames(tagGroupsStyles["label-margin"], settingsStyles["form-label-font"])}>
        {intl.formatMessage("settings.tagGroups.form.tags.label")}
      </p>
      <TagsList tags={tagsStore.getFromIds(tags.$)} />
    </div>
  );
});
